import { DocumentEditorPage } from '@jarvis/platform-ui';

export function SpreadsheetEditorPage() {
  return (
    <DocumentEditorPage
      mode="edit"
      kind="spreadsheet"
      filesLinkTo="/finance/secure-pharm-reports"
      filesLinkLabel="Secure Pharm Reports"
    />
  );
}
